import React, { FC } from 'react';

import { PropertySettingsActions } from 'src/components/property-settings/property-settings-actions/PropertySettingsActions';

import { usePropertySettings } from '../context';

export const ActionsSectionModule: FC = () => {
	const {
		state: { draft, isSaving },
		isListMode,
		save
	} = usePropertySettings();

	return (
		<PropertySettingsActions
			property={draft}
			isPropertyInListMode={isListMode}
			isSaveInProgress={isSaving}
			onSaveChanges={(shouldCrawl) => save({ draft, isListMode, shouldCrawl })}
		/>
	);
};
